import { Badge } from '@mantine/core';
import { tokens, type ReservationStatus } from '../ui/tokens.ts';

export function StatusBadge({ status }: { readonly status: ReservationStatus }) {
  const entry = tokens.status[status];
  return (
    <Badge color={entry.mantineColor} variant="light" size="lg" radius="xl">
      {entry.label}
    </Badge>
  );
}
